import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/store';
import { updateClinicalReviewDetails } from '../../../../../../services/CaseManagementService/caseManageSlice';

const statusOptions = [
  'Incomplete',
  'Pending',
  'Complete',
  'Not Required',
  'Does Not Support'
];

const PsychologicalEvaluationField: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentCase } = useAppSelector(state => state.caseManage);

  const handleChange = (value: string) => {
    dispatch(updateClinicalReviewDetails({
      psycologicalEvaluation: value
    }));
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>Psychological Evaluation</InputLabel>
      <Select
        value={currentCase?.clinicalReview?.psycologicalEvaluation || 'Incomplete'}
        onChange={(e) => handleChange(e.target.value)}
        label="Psychological Evaluation"
      >
        {statusOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PsychologicalEvaluationField;
